import { Component } from '@angular/core';
import { RestaurantOrderService } from '../../../providers';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap/modal/modal.module';
import { Router } from '@angular/router';

@Component({
  selector: 'cart-modal',
  styleUrls: ['./cart_modal.scss'],
  templateUrl: './cart_modal.pug',
})

export class CartModalComponent {
  cartData = JSON.parse(window.localStorage.getItem('cartOrder'));
  order: Object;
  orderId: number;
  restaurantId: number;

  constructor(private orderService: RestaurantOrderService,
              private router: Router,
              public activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.checkCartOrder();
  }

  checkCartOrder() {
    if(this.cartData && this.cartData['order_id']) {
      this.orderId = this.cartData.order_id;
      this.restaurantId = this.cartData.restaurant_id;
      this.getOrder();
    }
  }

  getOrder() {
    this.orderService.getOrder(this.restaurantId, this.orderId).subscribe((data) => {
      this.order = data;
    }, (err) => {});
  }

  goToCheckout() {
    this.activeModal.close();
    this.router.navigate(['/restaurants', this.restaurantId, 'checkout']);
  }
}



// WEBPACK FOOTER //
// ./src/components/+utils/cart_modal/cart_modal.ts